import { CtaButton } from './cta-button'
import { PT_FREE_PERKS, PT_PRO_PERKS } from './pricing-perks'
import { ScrollReveal } from './scroll-reveal'
import { TruchetField } from './truchet-field'

/* Pricing. Free and Profissional side by side, over a deep-purple field. */

const Check = () => (
  <svg aria-hidden="true" fill="none" height="18" viewBox="0 0 18 18" width="18">
    <rect height="16" rx="4" stroke="#c4c4c8" strokeWidth="1.4" width="16" x="1" y="1" />
    <path
      d="m5 9 2.5 2.5L13 6"
      stroke="#5b8def"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.6"
    />
  </svg>
)

export const PricingSection = () => (
  <section className="relative overflow-hidden bg-[#2c2338] py-28" id="pricing">
    <TruchetField
      className="absolute inset-0 h-full w-full text-white opacity-[0.05]"
      seed="pricing"
    />
    <div className="relative mx-auto max-w-[1120px] px-6">
      <ScrollReveal className="text-center">
        <h2 className="font-display text-[clamp(40px,6vw,58px)] text-white tracking-[-0.01em]">
          Planos
        </h2>
        <p className="mt-3 text-[#b2acc0] text-[clamp(17px,2.4vw,22px)]">
          Comece grátis. Cresça com o Planno.
        </p>
      </ScrollReveal>

      <div className="mt-16 grid items-start gap-6 md:grid-cols-2">
        {/* Free plan */}
        <ScrollReveal>
          <div className="relative rounded-3xl bg-[#f5f3fa] p-8">
            <img
              alt=""
              className="absolute -top-10 left-6 h-20 w-auto animate-mkt-float"
              decoding="async"
              height={392}
              loading="lazy"
              src="/pet-dog.png"
              width={400}
            />
            <p className="pt-4 font-semibold text-[#0b0b0d] text-[15px]">Pessoal</p>
            <div className="mt-2 flex items-end gap-2">
              <span className="font-bold text-[#0b0b0d] text-[52px] leading-none">R$ 0</span>
              <span className="pb-1.5">
                <span className="block font-semibold text-[#0b0b0d] text-[13px]">BRL</span>
                <span className="block text-[#8a8a90] text-[13px]">para sempre</span>
              </span>
            </div>
            <p className="mt-6 text-[#43434a] text-[15px] leading-relaxed">
              Para quem está começando e toca o escritório por conta própria.
            </p>
            <div className="mt-6 space-y-3">
              {PT_FREE_PERKS.map((perk) => (
                <div className="flex items-center gap-2.5" key={perk}>
                  <Check />
                  <span className="text-[#43434a] text-[15px]">{perk}</span>
                </div>
              ))}
            </div>
            <CtaButton
              className="mt-8 w-full"
              search={{ plan: 'free' }}
              size="lg"
              to="/sign-up"
              variant="dark"
            >
              Começar grátis
            </CtaButton>
          </div>
        </ScrollReveal>

        {/* Professional plan */}
        <ScrollReveal delay={120}>
          <div className="relative rounded-3xl bg-white p-8 shadow-[0_40px_80px_-30px_rgba(0,0,0,0.5)] ring-2 ring-[#ffde18]">
            <p className="font-semibold text-[#0b0b0d] text-[15px]">Profissional</p>
            <div className="mt-2 flex items-end gap-2">
              <span className="font-bold text-[#0b0b0d] text-[52px] leading-none">R$ 49</span>
              <span className="pb-1.5">
                <span className="block font-semibold text-[#0b0b0d] text-[13px]">BRL</span>
                <span className="block text-[#8a8a90] text-[13px]">por usuário · mês</span>
              </span>
            </div>
            <p className="mt-2 text-[#8a8a90] text-[13.5px]">
              ou <span className="font-semibold text-[#43434a]">R$ 499/ano</span> por usuário,
              economize 15%
            </p>
            <p className="mt-6 text-[#43434a] text-[15px] leading-relaxed">
              Tudo do Pessoal, mais o que o escritório precisa quando a equipe cresce.
            </p>
            <div className="mt-6 space-y-3">
              {PT_PRO_PERKS.map((perk) => (
                <div className="flex items-center gap-2.5" key={perk}>
                  <Check />
                  <span className="text-[#43434a] text-[15px]">{perk}</span>
                </div>
              ))}
            </div>
            <CtaButton
              className="mt-8 w-full"
              search={{ plan: 'pro' }}
              size="lg"
              to="/sign-up"
              variant="yellow"
            >
              Começar com Profissional
            </CtaButton>
          </div>
        </ScrollReveal>
      </div>
    </div>
  </section>
)
